/* eslint-disable no-unused-vars */

import { getValueFromInput } from "./utilities";

const animationCache = {};

function attachDrawSwitch(asset, handler) {
    const oldDraw = asset.prototype.draw;
    asset.prototype = Object.create(asset.prototype);
    asset.prototype.draw = function () {
        const shouldDraw = handler.call(this);

        if (shouldDraw) {
            return oldDraw.apply(this, arguments);
        } else {
            return false;
        }
    };
}

function loadAnimations(lang, animationNames, path) {
    return Promise.all(
        animationNames.map((name) => {
            let moduleName;
            if (lang === "en") {
                moduleName = `${path}/${name}`;
            } else {
                moduleName = `${path}-fr/${name}`;
            }

            if (animationCache[moduleName]) {
                return Promise.resolve(animationCache[moduleName]);
            }

            const src = `${moduleName}.js`;

            return new Promise((resolve) => {
                const scriptEl = document.createElement("script");
                scriptEl.src = src;
                scriptEl.onload = () =>
                    setTimeout(() => {
                        // eslint-disable-next-line no-undef
                        const animation = require(moduleName).default;

                        const lib = animation.composition.getLibrary();

                        lib.properties.manifest.forEach((item) => {
                            if (lang === "en") {
                                item.src = `${path}/${item.src}`;
                            } else {
                                item.src = `${path}-fr/${item.src}`;
                            }

                            item.loadTimeout = 300000;
                        });

                        animationCache[moduleName] = animation;
                        resolve(animation);
                    });

                document.head.appendChild(scriptEl);
            });
        })
    );
}

export { attachDrawSwitch, loadAnimations };
